
import { Component, Vue } from 'vue-property-decorator'
import NoticeMessageLayout from '@/components/templates/NoticeMessageLayout.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'
import { NotificationsApi } from '@/api/methods/NotificationsApi'

/**
 * お知らせメッセージ詳細画面
 */
@Component({
  components: {
    NoticeMessageLayout,
  },
})
export default class NoticeMessage extends Vue {
  /** メッセージ情報 */
  private message!: NoticeMessageData

  /** ページレンダリング制御用フラグ */
  private viewPage = false

  /**
   * お知らせID
   *
   * @returns お知らせID
   */
  private get messageId(): number {
    return Number(this.$route.params.id)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    this.message = await this.getMessage()
    this.viewPage = true

    this.$loading.complete()
  }

  /**
   * リンクボタン押下時の処理
   */
  private eventClickLinkButton(): void {
    // 遷移元ページ情報の復元
    const prevPage = this.$prevPage.restorePage()

    // 遷移元ページ情報がない場合
    if (!prevPage) {
      this.$router.push('/student/notice')
      return
    }

    this.$router.push({
      path: prevPage.path,
      query: prevPage.query,
    })
  }

  /**
   * お知らせをapiから取得
   *
   * @returns お知らせ情報
   */
  private async getMessage(): Promise<NoticeMessageData> {
    const noticeDetail = await NotificationsApi.notification(this.messageId)
    return {
      id: noticeDetail.id,
      type: noticeDetail.type,
      title: noticeDetail.title,
      startedDate: new Date(noticeDetail.startedAt * 1000),
      endedDate: new Date(noticeDetail.endedAt * 1000),
      description: noticeDetail.message,
      updatedUser: noticeDetail.updatedBy,
      updatedAt: new Date(noticeDetail.updatedAt * 1000),
    }
  }
}
